module.exports = __webpack_public_path__ + "static/media/team3.f055a479.png";